import React from 'react';
import { ArrowLeftIcon, Box, Button, Heading, Text, Link } from '@razorpay/blade/components';

import tnaCalendarIllustration from 'assets/tna-settings/tna-calendar.svg';
import { ENABLE_VALUE_PROPS } from '../constants';

interface AttendanceDisabledPageProps {
  onEnable: () => void;
}

export const AttendanceDisabledPage = ({ onEnable }: AttendanceDisabledPageProps) => {
  return (
    <Box
      paddingX="spacing.8"
      paddingY="spacing.8"
      minHeight="100%"
      display="flex"
      flexDirection="column">
      <Box>
        <Link variant="anchor" href="/settings" icon={ArrowLeftIcon} iconPosition="left">
          Back
        </Link>
        <Heading size="xlarge" marginTop="spacing.3">
          Time &amp; Attendance
        </Heading>
      </Box>

      <Box
        marginTop="spacing.8"
        backgroundColor="surface.background.gray.intense"
        borderWidth="thin"
        borderColor="surface.border.gray.muted"
        borderRadius="medium"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        flex={1}
        paddingX="spacing.9"
        paddingTop="spacing.0">
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          paddingY="spacing.10">
          <Box display="flex" alignItems="center" justifyContent="center">
            <img src={tnaCalendarIllustration} alt="" width={200} height="auto" />
          </Box>

          <Box marginTop="spacing.5" textAlign="center">
            <Heading size="medium">Set up Time &amp; Attendance</Heading>
            <Text marginTop="spacing.3" color="surface.text.gray.muted">
              Configure shifts, leave types, holidays and overtime policies.
            </Text>
          </Box>

          <Box marginTop="spacing.7">
            <Button variant="primary" size="large" onClick={onEnable}>
              Enable Time &amp; Attendance
            </Button>
          </Box>
        </Box>

        <Box
          display="flex"
          justifyContent="space-between"
          gap="spacing.7"
          paddingTop="spacing.5"
          paddingBottom="spacing.9">
          {ENABLE_VALUE_PROPS.map((prop) => (
            <Box
              key={prop.title}
              flex={1}
              borderLeftWidth="thick"
              borderColor="surface.border.primary.normal"
              paddingLeft="spacing.4">
              <Text weight="semibold" color="surface.text.gray.normal">
                {prop.title}
              </Text>
              <Text marginTop="spacing.1" size="medium" color="surface.text.gray.muted">
                {prop.description}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
